import { useAuth } from '../../services/authContext';

export function ImpersonationBanner() {
  const { impersonatedUser, isImpersonating, stopImpersonating } = useAuth();

  if (!isImpersonating || !impersonatedUser) return null;

  const name = [impersonatedUser.firstName, impersonatedUser.lastName].filter(Boolean).join(' ') || impersonatedUser.email;

  return (
    // In-flow layout row (not a fixed overlay) — see StagingBanner for why.
    <div className="shrink-0 bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shadow-md">
      <span>
        Acting as <strong>{name}</strong> ({impersonatedUser.email})
      </span>
      <button
        onClick={stopImpersonating}
        className="rounded bg-amber-700 hover:bg-amber-800 px-3 py-1 text-xs font-medium transition-colors"
      >
        Switch back
      </button>
    </div>
  );
}
